import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, Grid } from '@mui/material';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

export const FinancialInfoOverview: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = true;

  return (
    <Box>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('overviewTitle')}
          badgeText={t('overview.financialInformation.title')}
        />
      </FormSectionCard>

      <FormSectionCard>
        <Grid container spacing={3} alignItems="end">
          <Grid item xs={6}>
            {/* 0.4.1 */}
            <NumberInputControlled
              control={control}
              id="overview.financialInformation.projectedAnnualIncome"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECTED_ANNUAL_INCOME)}
              label={t('overview.financialInformation.projectedAnnualIncome')}
              adornmentType="currency"
              disabled={!canAccess}
            />
          </Grid>
          <Grid item xs={6}>
            {/* 0.4.2 */}
            <NumberInputControlled
              control={control}
              id="overview.financialInformation.forecastedProfitability"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.FORECASTED_PROFITABILITY)}
              label={t('overview.financialInformation.forecastedProfitability')}
              adornmentType="percentage"
              disabled={!canAccess}
            />
          </Grid>
          <Grid item xs={6}>
            {/* 0.4.3 */}
            <NumberInputControlled
              control={control}
              id="overview.financialInformation.projectedPlaybackPeriod"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECT_PAYBACK_PERIOD)}
              label={t('overview.financialInformation.projectedPlaybackPeriod')}
              disabled={!canAccess}
            />
          </Grid>
        </Grid>
      </FormSectionCard>
    </Box>
  );
};
